import styled from '@emotion/styled';

const Text = styled('span')({
  marginLeft: '1.5rem',
});

export default Text;
